import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AIONZ_TOOLTIP_DATA } from '@aionzdev/design-system';
import { BranchesSummary } from '../../../interfaces/branches-summary';

/** Tooltip do chip de filiais do card: para onde vão os itens do pedido. */
@Component({
  selector: 'aionz-branches-tooltip',
  imports: [MatIconModule],
  templateUrl: './branches-tooltip.component.html',
  styleUrl: './branches-tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BranchesTooltipComponent {
  protected readonly data = inject(AIONZ_TOOLTIP_DATA) as BranchesSummary;

  protected get countLabel(): string {
    const n = this.data.branches.length;
    return `${n} ${n === 1 ? 'endereço' : 'endereços'}`;
  }
}
